import { Component, input, output } from '@angular/core';
import { DeviceTask } from '@era/device-task-management-sdk';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { DeviceScheduledTasksCancelContainerComponent } from './device-scheduled-tasks-cancel/device-scheduled-tasks-cancel.container';

@Component({
  selector: 'era-device-scheduled-tasks-ui',
  templateUrl: './device-scheduled-tasks.component.html',
  imports: [FaIconComponent, DeviceScheduledTasksCancelContainerComponent],
})
export class DeviceScheduledTasksComponent {
  readonly scheduledTasks = input.required<DeviceTask[]>();
  readonly deleteEvent = output<DeviceTask>();

  public convertScheduledTask(task: string): string {
    const taskWithUppercase = task.charAt(0).toUpperCase() + task.slice(1);
    return taskWithUppercase.split('-').join(' ');
  }

  public deleteScheduledTask(event: DeviceTask) {
    this.deleteEvent.emit(event);
  }
}
